export default __webpack_public_path__ + "static/media/6.57e7e223.png";